import styled from 'foundations-theming/utils';
import Raven from 'raven-js';
export const BANNER_TYPES = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  DANGER: 'danger',
  TIP: 'tip',
  CRIT_SIT: 'critSit'
};
export const AlertTitle = styled.h5.withConfig({
  displayName: "AbstractBannerComponents__AlertTitle",
  componentId: "carxoa-0"
})(({
  fullWidthTitle,
  theme
}) => {
  return {
    fontWeight: 700,
    alignItems: 'center',
    margin: theme.space['0'],
    marginRight: theme.space[fullWidthTitle ? '0' : '500'],
    width: fullWidthTitle ? '100%' : 'auto'
  };
});
export const AlertWrapper = styled.div.withConfig({
  displayName: "AbstractBannerComponents__AlertWrapper",
  componentId: "carxoa-1"
})(["font-size:14px !important;display:flex;align-items:center;justify-content:space-between;border:solid 1px transparent !important;min-height:60px;padding:", ";position:relative;text-align:left;color:", " !important;", ";"], ({
  theme
}) => `${theme.space['200']} ${theme.space['500']} !important`, ({
  theme
}) => theme.color['text-core-default'], ({
  theme,
  type
}) => {
  if (type === BANNER_TYPES.DANGER) {
    return `
        background-color: ${theme.color['fill-alert-subtle']};
        border: 1px solid ${theme.color['fill-accent-red-hover']} !important;
      `;
  } else if (type === BANNER_TYPES.WARNING) {
    return `
        background-color: ${theme.color['fill-caution-subtle']};
        border: 1px solid ${theme.color['fill-caution-hover']} !important;
      `;
  } else if (type === BANNER_TYPES.SUCCESS) {
    return `
        background-color: ${theme.color['fill-positive-subtle']};
        border: 1px solid ${theme.color['fill-positive-hover']} !important;
      `;
  } else if (type === BANNER_TYPES.INFO) {
    return `
        background-color: ${theme.color['fill-info-subtle']};
        border: 1px solid ${theme.color['fill-info-hover']} !important;
      `;
  } else if (type === BANNER_TYPES.TIP) {
    return `
        background-color: ${theme.color['fill-surface-default']};
        border: 1px solid ${theme.color['border-interactive-default']} !important;
      `;
  } else if (type === BANNER_TYPES.CRIT_SIT) {
    return `
        background: repeating-linear-gradient(
        135deg,
        ${theme.color['fill-alert-hover']},
        ${theme.color['fill-alert-hover']} 24px,
        ${theme.color['fill-alert-default']} 24px,
        ${theme.color['fill-alert-default']} 48px
    ) !important;
        border: 1px solid ${theme.color['fill-accent-red-hover']} !important;
        color: ${theme.color['text-core-on-fill-default']} !important;
      `;
  } else {
    const neverType = type;
    Raven.captureMessage(`Unexpected type: ${neverType}`);
    return null;
  }
});